import { axiosAWSConsumer as axiosConsumer } from "../../utils";

export const claimTicket = async (dto) => {
  const { data } = await axiosConsumer.post("/desk-ticket", dto);
  return data?.details || data;
};

export const getPreSignedURL = async (fileType: string) => {
  const { data } = await axiosConsumer.get(
    `/desk-ticket/file-upload-url?fileType=${fileType}`
  );
  const tempUrl = new URL(data?.url);
  tempUrl.search = "";
  return {
    uploadUrl: data?.url,
    publicUrl: tempUrl.toString(),
  };
};
